/**
 * Avisos benignos que o navegador dispara como evento `error` global, mas que
 * não indicam falha real da aplicação e NÃO devem acionar a tela de erro fatal.
 *
 * "ResizeObserver loop..." significa apenas que notificações de resize foram
 * adiadas para o próximo frame (comum com menus/overlays do Vuetify). O evento
 * chega sem `event.error`, sem stack e sem linha.
 */
const BENIGN_ERROR_PATTERNS: RegExp[] = [
    /ResizeObserver loop completed with undelivered notifications/i,
    /ResizeObserver loop limit exceeded/i
];

export function isBenignBrowserError(message: unknown): boolean {
    if (typeof message !== 'string') return false;
    return BENIGN_ERROR_PATTERNS.some((pattern) => pattern.test(message));
}
